import {ApplicationState, DormerState} from "../../";

export interface DormerApplicationState {
  dormerState: DormerState;
  applicationStateReducer: ApplicationState;
}
